// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3XSNm","col":"styles_col__2sXxi"};